import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { Icon } from "@sellar-io/components";
import { IconType } from "@sellar-io/components";

export const Tag = ({
  className,
  children,
  onClick,
  icon,
}: {
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  icon?: IconType;
}) => {
  const hasLabel =
    children !== null &&
    children !== undefined &&
    (typeof children !== "string" || children.trim().length > 0);

  return (
    <div
      className={twMerge(
        "flex flex-none cursor-pointer items-center rounded-lg border border-zinc-300 bg-white px-3 py-2 text-sm font-medium shadow-md hover:bg-zinc-200",
        className,
      )}
      onClick={onClick}
    >
      {!!icon && (
        <Icon
          className={twMerge("flex-none", hasLabel && "mr-2")}
          size={0.8}
          icon={icon}
        />
      )}
      {children}
      {!!onClick && <Icon className="ml-2" icon="CLOSE" />}
    </div>
  );
};
